import * as THREE from 'three';

function OrbitPaths({ selectedPlanet,planetData }) {
  return (
    <group>
      {planetData.map((planet, index) => {
        const points = [];
        for (let i = 0; i <= 64; i++) {
          const angle = (i / 64) * Math.PI * 2;
          points.push(new THREE.Vector3(
            Math.cos(angle) * planet.distance,
            0,
            Math.sin(angle) * planet.distance
          ));
        }
        
        const geometry = new THREE.BufferGeometry().setFromPoints(points);
        const isSelected = selectedPlanet && selectedPlanet.name === planet.name;
        
        return (
          <line key={index} geometry={geometry}>
            <lineBasicMaterial 
              color={isSelected ? planet.color : "#333333"} 
              transparent 
              opacity={isSelected ? 0.8 : 0.3} 
            />
          </line>
        );
      })}
    </group>
  );
}
export default OrbitPaths